query getUniversityData($university: String!) {
    getUniversityData(university: $university)
}
